// GoogleAcount + ManagerGoogleSheet + SettingService i18n fragment
const fragment = {
  vi: {
    // ===== GoogleAcount =====
    'ggAcc.list.title': 'Tài khoản Google',
    'ggAcc.list.add': 'Thêm',
    'ggAcc.list.searchLabel': 'Tìm kiếm tài khoản',
    'ggAcc.list.searchPlaceholder': 'Nhập tên hoặc email...',
    'ggAcc.list.search': 'Tìm kiếm',
    'ggAcc.list.reset': 'Đặt lại',

    'ggAcc.form.title.create': 'Tạo tài khoản Google',
    'ggAcc.form.title.update': 'Cập nhật tài khoản Google',
    'ggAcc.form.signIn': 'Đăng nhập Google',
    'ggAcc.form.field.name': 'Tên',
    'ggAcc.form.field.email': 'Email',
    'ggAcc.form.field.userId': 'User ID',
    'ggAcc.form.cancel': 'Hủy',
    'ggAcc.form.create': 'Tạo',
    'ggAcc.form.update': 'Cập nhật',
    'ggAcc.form.toast.loginDenied': 'Google từ chối đăng nhập: {reason}',
    'ggAcc.form.toast.invalidState': 'State OAuth không hợp lệ, vui lòng đăng nhập lại.',
    'ggAcc.form.toast.fetchError': 'Lấy thông tin Google thất bại',
    'ggAcc.form.toast.needLogin': 'Bạn cần đăng nhập Google trước khi tạo tài khoản.',
    'ggAcc.form.toast.created': 'Tạo tài khoản thành công.',
    'ggAcc.form.toast.createError': 'Tạo tài khoản thất bại',
    'ggAcc.form.toast.missingClientId': 'Thiếu cấu hình REACT_APP_GOOGLE_CLIENT_ID.',
    'ggAcc.form.toast.invalidFile': 'File chỉ hỗ trợ định dạng .png, .jpeg, .jpg',

    'ggAcc.table.col.name': 'Tên tài khoản',
    'ggAcc.table.col.email': 'Email',
    'ggAcc.table.col.status': 'Trạng thái',
    'ggAcc.table.col.createdAt': 'Ngày tạo',
    'ggAcc.table.col.actions': 'Thao tác',
    'ggAcc.table.tooltip.edit': 'Chỉnh sửa tài khoản',
    'ggAcc.table.tooltip.refresh': 'Cấp lại quyền / làm mới scope',
    'ggAcc.table.tooltip.delete': 'Xóa tài khoản',
    'ggAcc.table.toast.statusChanged': 'Đã thay đổi trạng thái tài khoản',
    'ggAcc.table.toast.statusError': 'Thay đổi trạng thái tài khoản thất bại',
    'ggAcc.table.delete.title': 'Xoá tài khoản Google?',
    'ggAcc.table.delete.desc': 'Hành động này không thể hoàn tác.',
    'ggAcc.table.delete.confirm': 'Xoá',
    'ggAcc.table.toast.deleted': 'Xóa tài khoản thành công',
    'ggAcc.table.toast.deleteError': 'Xóa tài khoản thất bại',
    'ggAcc.table.refresh.title': 'Cấp lại quyền cho tài khoản?',
    'ggAcc.table.refresh.desc':
      'Bạn sẽ được chuyển tới màn hình đăng nhập Google để cấp lại/mở rộng quyền. Token và scope mới sẽ được cập nhật vào đúng tài khoản này (giữ nguyên dữ liệu liên kết).',
    'ggAcc.table.refresh.confirm': 'Tiếp tục',
    'ggAcc.table.toast.refreshed': 'Refresh tài khoản thành công',
    'ggAcc.table.empty.title': 'Chưa có tài khoản Google nào',
    'ggAcc.table.empty.desc': 'Hãy thêm tài khoản đầu tiên để bắt đầu sử dụng',
    'ggAcc.table.empty.action': 'Thêm tài khoản',

    // ===== ManagerGoogleSheet =====
    'ggSheet.list.title': 'Danh sách Link GoogleSheet',
    'ggSheet.list.create': 'Tạo Link GoogleSheet',
    'ggSheet.list.searchLabel': 'Tìm kiếm',
    'ggSheet.list.reset': 'Tải lại',
    'ggSheet.list.search': 'Tìm kiếm',

    'ggSheet.modal.title': 'Tạo Link GoogleSheet',
    'ggSheet.modal.field.name': 'Tên',
    'ggSheet.modal.field.url': 'Link GoogleSheet',
    'ggSheet.modal.cancel': 'Hủy',
    'ggSheet.modal.submit': 'Tạo Link GoogleSheet',
    'ggSheet.modal.toast.created': 'Tạo Link GoogleSheet thành công',
    'ggSheet.modal.toast.error': 'Tạo Link GoogleSheet thành công',

    'ggSheet.table.col.name': 'Tên',
    'ggSheet.table.col.url': 'Url',
    'ggSheet.table.col.actions': 'Thao tác',
    'ggSheet.table.tooltip.edit': 'Cập nhật Google Sheet',
    'ggSheet.table.tooltip.delete': 'Xóa Google Sheet',
    'ggSheet.table.copyUrl': 'Sao chép URL',
    'ggSheet.table.delete.title': 'Xoá đường dẫn?',
    'ggSheet.table.delete.desc': 'Đường dẫn Google Sheet sẽ bị xoá khỏi hệ thống.',
    'ggSheet.table.delete.confirm': 'Xoá',
    'ggSheet.table.toast.deleted': 'Xóa đường dẫn thành công',
    'ggSheet.table.toast.deleteError': 'Xóa đường dẫn không thành công',
    'ggSheet.table.empty.title': 'Chưa có dữ liệu',
    'ggSheet.table.empty.desc': 'Hãy thêm bản ghi đầu tiên để bắt đầu',

    // ===== SettingService =====
    'setting.list.title': 'Danh sách tài khoản dịch vụ',
    'setting.list.add': 'Thêm',
    'setting.list.searchLabel': 'Tìm kiếm',
    'setting.list.reset': 'Tải lại',
    'setting.list.search': 'Tìm kiếm',

    'setting.create.title': 'Cập nhật tài khoản dịch vụ',
    'setting.create.field.id': 'ID',
    'setting.create.field.clientEmail': 'Email khách hàng',
    'setting.create.field.clientId': 'Client ID',
    'setting.create.field.projectId': 'Project ID',
    'setting.create.cancel': 'Hủy',
    'setting.create.submit': 'Cập nhật',
    'setting.create.toast.updated': 'Cập nhật tài khoản dịch vụ thành công',
    'setting.create.toast.updateError': 'Cập nhật tài khoản dịch vụ không thành công',

    'setting.modal.title.create': 'Tạo tài khoản dịch vụ',
    'setting.modal.title.update': 'Cập nhật tài khoản dịch vụ',
    'setting.modal.field.id': 'ID',
    'setting.modal.field.email': 'Email',
    'setting.modal.field.clientId': 'Client ID',
    'setting.modal.field.projectId': 'Project ID',
    'setting.modal.cancel': 'Hủy',
    'setting.modal.create': 'Tạo',
    'setting.modal.update': 'Cập nhật',
    'setting.modal.toast.created': 'Tạo thông tin thành công',
    'setting.modal.toast.updated': 'Cập nhật thông tin thành công',

    'setting.table.col.id': 'ID',
    'setting.table.col.email': 'Email',
    'setting.table.col.createdAt': 'Ngày tạo',
    'setting.table.col.actions': 'Thao tác',
    'setting.table.tooltip.settings': 'Cài đặt service',
    'setting.table.tooltip.loginGoogle': 'Đăng nhập Google',
    'setting.table.tooltip.delete': 'Xóa service',
    'setting.table.login.title': 'Đăng nhập Google?',
    'setting.table.login.desc': 'Tiếp tục đăng nhập với tài khoản đã cấu hình.',
    'setting.table.login.confirm': 'Đăng nhập',
    'setting.table.delete.title': 'Xoá đường dẫn?',
    'setting.table.delete.desc': 'Hành động này không thể hoàn tác.',
    'setting.table.delete.confirm': 'Xoá',
    'setting.table.toast.deleted': 'Xóa đường dẫn thành công',
    'setting.table.toast.deleteError': 'Xóa đường dẫn không thành công',
    'setting.table.empty.title': 'Chưa có dữ liệu',
    'setting.table.empty.desc': 'Hãy thêm bản ghi đầu tiên để bắt đầu',
  },

  en: {
    // ===== GoogleAcount =====
    'ggAcc.list.title': 'Google Accounts',
    'ggAcc.list.add': 'Add',
    'ggAcc.list.searchLabel': 'Search account',
    'ggAcc.list.searchPlaceholder': 'Enter name or email...',
    'ggAcc.list.search': 'Search',
    'ggAcc.list.reset': 'Reset',

    'ggAcc.form.title.create': 'Create Google account',
    'ggAcc.form.title.update': 'Update Google account',
    'ggAcc.form.signIn': 'Sign in with Google',
    'ggAcc.form.field.name': 'Name',
    'ggAcc.form.field.email': 'Email',
    'ggAcc.form.field.userId': 'User ID',
    'ggAcc.form.cancel': 'Cancel',
    'ggAcc.form.create': 'Create',
    'ggAcc.form.update': 'Update',
    'ggAcc.form.toast.loginDenied': 'Google denied sign-in: {reason}',
    'ggAcc.form.toast.invalidState': 'Invalid OAuth state, please sign in again.',
    'ggAcc.form.toast.fetchError': 'Failed to fetch Google information',
    'ggAcc.form.toast.needLogin': 'You must sign in with Google before creating an account.',
    'ggAcc.form.toast.created': 'Account created successfully.',
    'ggAcc.form.toast.createError': 'Failed to create account',
    'ggAcc.form.toast.missingClientId': 'Missing REACT_APP_GOOGLE_CLIENT_ID configuration.',
    'ggAcc.form.toast.invalidFile': 'File only supports .png, .jpeg, .jpg formats',

    'ggAcc.table.col.name': 'Account name',
    'ggAcc.table.col.email': 'Email',
    'ggAcc.table.col.status': 'Status',
    'ggAcc.table.col.createdAt': 'Created at',
    'ggAcc.table.col.actions': 'Actions',
    'ggAcc.table.tooltip.edit': 'Edit account',
    'ggAcc.table.tooltip.refresh': 'Re-authorize / refresh scope',
    'ggAcc.table.tooltip.delete': 'Delete account',
    'ggAcc.table.toast.statusChanged': 'Account status changed',
    'ggAcc.table.toast.statusError': 'Failed to change account status',
    'ggAcc.table.delete.title': 'Delete Google account?',
    'ggAcc.table.delete.desc': 'This action cannot be undone.',
    'ggAcc.table.delete.confirm': 'Delete',
    'ggAcc.table.toast.deleted': 'Account deleted successfully',
    'ggAcc.table.toast.deleteError': 'Failed to delete account',
    'ggAcc.table.refresh.title': 'Re-authorize this account?',
    'ggAcc.table.refresh.desc':
      'You will be redirected to the Google sign-in screen to re-grant/expand permissions. The new token and scope are saved back to this same account (linked data is preserved).',
    'ggAcc.table.refresh.confirm': 'Continue',
    'ggAcc.table.toast.refreshed': 'Account refreshed successfully',
    'ggAcc.table.empty.title': 'No Google accounts yet',
    'ggAcc.table.empty.desc': 'Add your first account to get started',
    'ggAcc.table.empty.action': 'Add account',

    // ===== ManagerGoogleSheet =====
    'ggSheet.list.title': 'GoogleSheet Link List',
    'ggSheet.list.create': 'Create GoogleSheet Link',
    'ggSheet.list.searchLabel': 'Search',
    'ggSheet.list.reset': 'Reload',
    'ggSheet.list.search': 'Search',

    'ggSheet.modal.title': 'Create GoogleSheet Link',
    'ggSheet.modal.field.name': 'Name',
    'ggSheet.modal.field.url': 'GoogleSheet Link',
    'ggSheet.modal.cancel': 'Cancel',
    'ggSheet.modal.submit': 'Create GoogleSheet Link',
    'ggSheet.modal.toast.created': 'GoogleSheet Link created successfully',
    'ggSheet.modal.toast.error': 'Failed to create GoogleSheet Link',

    'ggSheet.table.col.name': 'Name',
    'ggSheet.table.col.url': 'Url',
    'ggSheet.table.col.actions': 'Actions',
    'ggSheet.table.tooltip.edit': 'Update Google Sheet',
    'ggSheet.table.tooltip.delete': 'Delete Google Sheet',
    'ggSheet.table.copyUrl': 'Copy URL',
    'ggSheet.table.delete.title': 'Delete link?',
    'ggSheet.table.delete.desc': 'The Google Sheet link will be removed from the system.',
    'ggSheet.table.delete.confirm': 'Delete',
    'ggSheet.table.toast.deleted': 'Link deleted successfully',
    'ggSheet.table.toast.deleteError': 'Failed to delete link',
    'ggSheet.table.empty.title': 'No data yet',
    'ggSheet.table.empty.desc': 'Add your first record to get started',

    // ===== SettingService =====
    'setting.list.title': 'Service Account List',
    'setting.list.add': 'Add',
    'setting.list.searchLabel': 'Search',
    'setting.list.reset': 'Reload',
    'setting.list.search': 'Search',

    'setting.create.title': 'Update service account',
    'setting.create.field.id': 'ID',
    'setting.create.field.clientEmail': 'Client email',
    'setting.create.field.clientId': 'Client ID',
    'setting.create.field.projectId': 'Project ID',
    'setting.create.cancel': 'Cancel',
    'setting.create.submit': 'Update',
    'setting.create.toast.updated': 'Service account updated successfully',
    'setting.create.toast.updateError': 'Failed to update service account',

    'setting.modal.title.create': 'Create service account',
    'setting.modal.title.update': 'Update service account',
    'setting.modal.field.id': 'ID',
    'setting.modal.field.email': 'Email',
    'setting.modal.field.clientId': 'Client ID',
    'setting.modal.field.projectId': 'Project ID',
    'setting.modal.cancel': 'Cancel',
    'setting.modal.create': 'Create',
    'setting.modal.update': 'Update',
    'setting.modal.toast.created': 'Information created successfully',
    'setting.modal.toast.updated': 'Information updated successfully',

    'setting.table.col.id': 'ID',
    'setting.table.col.email': 'Email',
    'setting.table.col.createdAt': 'Created at',
    'setting.table.col.actions': 'Actions',
    'setting.table.tooltip.settings': 'Service settings',
    'setting.table.tooltip.loginGoogle': 'Sign in with Google',
    'setting.table.tooltip.delete': 'Delete service',
    'setting.table.login.title': 'Sign in with Google?',
    'setting.table.login.desc': 'Continue signing in with the configured account.',
    'setting.table.login.confirm': 'Sign in',
    'setting.table.delete.title': 'Delete link?',
    'setting.table.delete.desc': 'This action cannot be undone.',
    'setting.table.delete.confirm': 'Delete',
    'setting.table.toast.deleted': 'Link deleted successfully',
    'setting.table.toast.deleteError': 'Failed to delete link',
    'setting.table.empty.title': 'No data yet',
    'setting.table.empty.desc': 'Add your first record to get started',
  },
};

export default fragment;
